<template>
  <v-card class="list-group-item mb-3">
    <v-card-title class="pt-2 pr-2 pb-0 pl-2">
      <v-layout row>
        <v-flex xs6>
          <router-link :to="{ path: `/boards/${board.id}/tickets/${ticket.attributes.sequential_id}` }" class="link">
            <span class='ticket-number pa-1 pl-2 pr-2 mr-2' :style="{'border-color': status.attributes.color }">
              {{ticket.attributes.sequential_id}}
            </span>
          </router-link>
        </v-flex>
        <v-flex xs6 text-xs-right>
          <v-avatar size=24>
            <img :src="assigneeThumbUrl" alt="Avatar" v-if="assigneeThumbUrl" class="assigneeLogo">
            <v-icon v-else>person_outline</v-icon>
          </v-avatar>

          <v-btn icon small @click="unsetWatch()" class="ma-0" v-if="watch">
            <v-icon small>visibility</v-icon>
          </v-btn>
          <v-btn icon small @click="setWatch()" class="ma-0" v-else>
            <v-icon small color="grey">visibility_off</v-icon>
          </v-btn>
          <v-btn small icon class="ma-0" v-show="permit.canEditTicket(ticket)">
            <v-icon small color="grey">drag_indicator</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-card-title>

    <v-card-title class="pt-0 pr-2 pb-0 pl-2">
      <v-layout row>
        <v-flex xs12>
          <v-tooltip bottom>
            <router-link slot="activator" :to="{ path: `/boards/${board.id}/tickets/${ticket.attributes.sequential_id}` }" class="link">
              <span class="link ticket-title font-weight-bold">
                {{ticket.attributes.title}}
              </span>
            </router-link>
            {{ticket.attributes.title}}
          </v-tooltip>
        </v-flex>
      </v-layout>
    </v-card-title>

    <v-card-text>
      <v-layout>
        <v-flex xs6>
          <v-tooltip bottom>
            <span slot="activator">
              <div class="caption text-no-wrap text-truncate pb-1"><v-icon small class="pr-2">edit</v-icon>{{ticket.attributes.updated_at|formatDateAgo}}</div>
            </span>
          {{ticket.attributes.updated_at|formatDateLong}}</div>
          </v-tooltip>
        </v-flex>
        <v-flex xs6>
          <span class="caption text-no-wrap text-truncate pb-1"><v-icon small class="pr-2">forum</v-icon>{{ticket.relationships.comments.data.length}} comments</span>
        </v-flex>
      </v-layout>
    </v-card-text>
  </v-card>
</template>

<script>
  import permissions from '@/utilities/permissions'
  import authentication from '@/utilities/authentication'

  import watchService from '@/services/watch'

  export default {
    name: 'board-ticket-card',

    components: {
    },

    props: ['ticket', 'membership', 'status', 'board'],

    data () {
      return {
        permit: permissions,
        auth: authentication,
        watch: null
      }
    },

    mounted () {
      this.loadTicketWatches()
    },

    computed: {
      assigneeThumbUrl () {
        if (this.membership && this.membership.links && this.membership.links.avatar_uri) {
          return (process.env.API_URL + this.membership.links.avatar_uri)
        }
      }
    },

    methods: {
      loadTicketWatches () {
        watchService.ticketIndex(
          (data) => {
            this.watch = data.find(watch => this.auth.isCurrentUser(watch.relationships.user.data.id))
          },
          (err) => {
            console.log(err)
          },
          this.ticket.id
        )
      },

      setWatch () {
        watchService.ticketCreate(
          (data) => {
            this.watch = data
          },
          (err) => {
            console.log(err)
          },
          this.ticket.id,
          {user_id: this.auth.userId()}
        )
      },

      unsetWatch () {
        watchService.ticketDelete(
          (data) => {
            this.watch = null
          },
          (err) => {
            console.log(err)
          },
          this.ticket.id,
          this.watch.id
        )
      }
    }
  }
</script>

<style lang="scss" scoped>
  .link{
    color: #757575;
    text-decoration: none;
  }

  .link:hover{
    color: #757575;
    text-decoration: none;
  }

  .ticket-number {
    border-radius: 15%;
    border: 1px solid; /*color is dynamic, see markup*/
  }

  .ticket-title {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: inline-block;
    width: 100%;
  }

  .float-right {
    float: right;
  }

  img.assigneeLogo {
    border: 2px solid lightgrey;
  }
</style>



// WEBPACK FOOTER //
// src/components/board/_ticketCard.vue